'use client';

import BigArrow from '@/fo/icons/base/icons/big-arrow.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import { ArticleButton } from '../components/ArticleButton/ArticleButton';
import { ArticleTile } from '../components/ArticleTile/ArticleTile';
import { RubricArticle, RubricItem } from '../types';

import { styles } from './UiArticleSectionTopFive.styles';

export interface UiArticleSectionTopFiveProps {
  title: string;
  rubrics: RubricItem[];
  article: RubricArticle | null;
  href: string;
  description?: string;
  allPostsLabel: string;
  readAnotherPostLabel: string;
}

export function UiArticleSectionTopFive({
  title,
  rubrics,
  article,
  href,
  description,
  allPostsLabel,
  readAnotherPostLabel
}: UiArticleSectionTopFiveProps) {
  const slots = styles();

  return (
    <div className={slots.section()}>
      <div className={slots.container()}>
        <div className={slots.base()}>
          <div className={slots.left()}>
            <div className={slots.title()}>{title}</div>
            {description && (
              <div className={slots.description()}>{description}</div>
            )}
            <div className={slots.rubrics()}>
              {article && (
                <ArticleButton
                  className={slots.articleButton()}
                  data={article}
                />
              )}

              {rubrics.map((rubric) => (
                <ArticleButton
                  key={rubric.id}
                  data={rubric}
                />
              ))}
            </div>
            <UiKitButtonBase
              className={slots.button()}
              childrenClassName={slots.buttonChildren()}
              color="ghost"
              href={href}
              as="link"
            >
              <span>{allPostsLabel}</span> <BigArrow />
            </UiKitButtonBase>
          </div>
          <div className={slots.right()}>
            {article && (
              <ArticleTile
                article={article}
                readArticle={readAnotherPostLabel}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
